import { FeatureToggleClientService } from 'feature-toggle-client';
const UseConfigurationsDomainOnIntegrationOperationsGet = 'use-configurations-domain-on-integrations-operations-get';
const UseConfigurationsDomainOnIntegrationOperationsSet = 'use-configurations-domain-on-integrations-operations-set';
const EnableRdStationIntegration = 'enable-rd-station-integration';
export class IntegrationsFeatures {
    static checkFeatureToggle(featureToggleName, defaultValue = false) {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(featureToggleName, defaultValue);
    }
    static async isConfigurationsDomainOnChannelsOperationsGetEnabled() {
        return await IntegrationsFeatures.checkFeatureToggle(UseConfigurationsDomainOnIntegrationOperationsGet, false);
    }
    static async isConfigurationsDomainOnChannelsOperationsSetEnabled() {
        return await IntegrationsFeatures.checkFeatureToggle(UseConfigurationsDomainOnIntegrationOperationsSet, false);
    }
    static async rdStationIntegrationSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(EnableRdStationIntegration);
    }
}
